import { useTranslation } from 'react-i18next';

export default function CtaFullSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20fashion%20products%20and%20accessories%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20neutral%20warm%20tones%2C%20elegant%20spread%20arrangement%2C%20shoes%20bags%20clothing%20accessories%2C%20high%20quality%20lifestyle%20aesthetic&width=1800&height=800&seq=cta-full-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/45"></div>
      </div>

      <div className="relative z-10 px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-10 max-w-xl mx-auto">
            {t('cta.description_line1')}
            <br />
            {t('cta.description_line2')}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-950 font-semibold text-sm rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>{t('cta.button')}</span>
            <div className="w-6 h-6 rounded-full bg-foreground-950 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs text-white"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}